import { useState, type FormEvent } from 'react';
import { Alert, Button, Field, Input } from '@busbook/ui';
import { ApiError } from '@busbook/ui';
import { useSession } from '../lib/session.js';
import { useT } from '../i18n/index.js';

export function SignIn() {
  const t = useT();
  const { signIn } = useSession();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(
        err instanceof ApiError && err.code === 'AUTH_INVALID'
          ? 'Email or password is incorrect.'
          : 'Sign in failed. Try again.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="grid min-h-screen place-items-center px-6">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex items-center gap-2">
          <span
            className="grid h-7 w-7 place-items-center rounded text-xs font-bold"
            style={{ background: 'var(--color-primary)', color: '#fff' }}
            aria-hidden
          >
            B
          </span>
          <span className="font-semibold tracking-tight">{t('brand.ops')}</span>
        </div>

        <h1 className="text-xl font-semibold tracking-tight">{t('signIn.submit')}</h1>
        <p className="mt-1 text-sm" style={{ color: 'var(--color-muted)' }}>
          {t('signIn.subtitle')}
        </p>

        <form onSubmit={submit} className="mt-6 flex flex-col gap-4">
          <Field label={t('signIn.email')} htmlFor="email">
            <Input
              id="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Field>
          <Field label={t('signIn.password')} htmlFor="password">
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>
          {error && <Alert tone="error">{error}</Alert>}
          <Button type="submit" size="lg" block loading={busy}>
            {t('signIn.submit')}
          </Button>
        </form>
      </div>
    </main>
  );
}
